<template>
  <v-container>
    <div
      class="search-wrapper d-flex align center"
      style="margin-left: 160px; margin-top: -30px"
    >
      <v-row class="hidden-md-and-up">
        <v-col cols="12">
          <v-btn color="blue" large fab @click="afficheListes = !afficheListes">
            <v-icon class="icone" color="white">mdi-magnify</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-show="afficheListes">
        <!-- denominations -->
        <v-col cols="12" md="3">
          <app-search-field type="deno"></app-search-field>
        </v-col>
        <v-spacer></v-spacer>

        <!-- fournisseurs -->
        <v-col cols="12" md="3">
          <app-search-field type="frn"></app-search-field>
        </v-col>

        <v-spacer></v-spacer>

        <!-- produits -->
        <v-col cols="12" md="3">
          <app-search-field type="prod"></app-search-field>
        </v-col>

        <v-spacer></v-spacer>

        <!-- multi-critères-->
        <v-col cols="12" md="3">
          <span
            class="multi-crit"
            @click="navigateToMc"
            style="cursor: pointer"
          >
            <v-combobox
              disabled
              prepend-inner-icon="mdi-briefcase-search"
              style="background: transparent"
              class="inputSearch"
              label="Recherche multi-critères"
              color="#f04e1a"
              variant="underlined"
              density="default"
            >
            </v-combobox>
          </span>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import AppSearchField from "@/components/AppSearchField";

export default {
  name: "AppSearch",
  components: {
    AppSearchField,
  },
  data() {
    return {
      afficheListes: true,
    };
  },
  methods: {
    onResize() {
      this.setAfficheOptions();
    },
    setAfficheOptions() {
      //console.log("width", this.$vuetify.breakpoint.width);
      //console.log("sm threshold", this.$vuetify.breakpoint.thresholds.sm);
      //console.log("name", this.$vuetify.breakpoint.name);

      this.afficheListes =
        //   this.$vuetify.breakpoint.width >=
        //   this.$vuetify.breakpoint.thresholds.sm;
        this.$vuetify.breakpoint.mdAndUp;
    },
    navigateToMc(evt) {
      evt.target.blur();
      if (this.$route.name != "multiCriteres") {
        this.$router.push({ name: "multiCriteres" });
      }
    },
  },
  mounted() {
    this.setAfficheOptions();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
<style>
.icone {
  display: flex !important;
  justify-content: right !important;
  transform: rotate(90deg);
}
.multi-crit .v-input__control input,
.multi-crit .theme--light.v-icon {
  cursor: pointer;
}
.multi-crit .theme--light.v-text-field .v-input__control .v-input__slot:before {
  border-color: #f04e1a !important;
  border-image: none;
}

.multi-crit .theme--light.v-label,
.multi-crit .theme--light.v-icon.v-icon.v-icon--disabled {
  color: #f04e1a !important;
}
</style>
